import React from 'react';
import positionMap from './positions.json';
export default function ClockHands({ position }) {
  const defaultPosition = positionMap['neutral'];
  return (
    <div className="blue-box">
      <div
        className="line"
        style={{
          transform: `rotate(${
            position
              ? positionMap[`${position}`]['rotate1']
              : defaultPosition['rotate1']
          })`,
        }}
      />
      <div
        className="line"
        style={{
          transform: `rotate(${
            position
              ? positionMap[`${position}`]['rotate2']
              : defaultPosition['rotate2']
          })`,
        }}
      />
    </div>
  );
}
